<div class="app-layout" [class.assistant-open]="isOpen$ | async">
  <div class="app-content">
    <router-outlet></router-outlet>
    <app-toast-container></app-toast-container>
  </div>

  <!-- Global AI assistant sidebar — slides in alongside content, no backdrop -->
  <aside
    class="assistant-tray"
    [class.assistant-tray--open]="isOpen$ | async"
    id="assistantTray"
    aria-label="AI Assistant"
  >
    <csn-ai-chat></csn-ai-chat>
  </aside>
</div>
